module.exports = __webpack_public_path__ + "static/media/icon-arrow-up.0b6d85d9.svg";